import React from 'react';
import { X } from 'lucide-react';
import { getHolidayBanner, type Holiday } from '../lib/holidays';

interface HolidayBannerProps {
  onClose?: () => void;
}

export const HolidayBanner: React.FC<HolidayBannerProps> = ({ onClose }) => {
  const [dismissed, setDismissed] = React.useState(false);
  const { show, holiday } = getHolidayBanner();

  if (!show || !holiday || dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    onClose?.();
  };

  return (
    <div 
      className={`relative overflow-hidden bg-gradient-to-r ${holiday.theme.bg} border-b border-white/10`}
      style={{ '--accent': holiday.theme.accent } as React.CSSProperties}
    >
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-center gap-3">
          <span className="text-2xl">{holiday.theme.emoji}</span>
          <div className="text-center">
            <span 
              className="font-bold text-white"
              style={{ color: holiday.theme.accent }}
            >
              {holiday.theme.greeting}
            </span>
            {holiday.theme.greetingAmharic && (
              <span className="text-white/80 ml-2">
                {holiday.theme.greetingAmharic}
              </span>
            )}
          </div>
          <span className="text-2xl">{holiday.theme.emoji}</span>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(5)].map((_, i) => (
          <span
            key={i}
            className="absolute text-2xl opacity-20 animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${i * 0.5}s`,
            }}
          >
            {holiday.theme.emoji}
          </span>
        ))}
      </div>

      {/* Close button */}
      <button
        onClick={handleDismiss}
        className="absolute right-4 top-1/2 -translate-y-1/2 p-1 text-white/50 hover:text-white transition-colors"
      >
        <X size={18} />
      </button>
    </div>
  );
};

export default HolidayBanner;


